import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const pageBlockTitleSizes = ["XS", "S", "M", "L", "XL"] as const;
type PageBlockTitleSize = (typeof pageBlockTitleSizes)[number];
const pageBlockTitleSize = toObjectMap<PageBlockTitleSize>([
    ...pageBlockTitleSizes,
]);

const pageBlockTitleSizeNames: Record<PageBlockTitleSize, Translatable> = {
    XS: translation({
        sv: "Extra liten",
        en: "Extra small",
    }),
    S: translation({
        sv: "Liten",
        en: "Small",
    }),
    M: translation({
        sv: "Medium",
        en: "Medium",
    }),
    L: translation({
        sv: "Stor",
        en: "Large",
    }),
    XL: translation({
        sv: "Extra stor",
        en: "Extra Large",
    }),
};

const pageBlockTitleSizeZodSchema = z.enum(pageBlockTitleSizes);

export {
    pageBlockTitleSize,
    pageBlockTitleSizeNames,
    pageBlockTitleSizes,
    pageBlockTitleSizeZodSchema,
};
export type { PageBlockTitleSize };
